import styled from 'styled-components';

export default styled.div`
  text-align: center;
  position: relative;
  display: inline-block;
  justify-content: center;
  line-height: 5rem;
  height: 5rem;
  border-radius: 1rem;
  font-weight: 500;
  cursor: pointer;
  background: #9058FF;
  color: #FFFFFF;
  font-size: 1.5rem;
  min-width: 13rem;
  user-select: none;
  padding: 0 2rem;
  margin-right: 1rem;
  display: inline-flex;
  align-items: center;
  max-width: fit-content;


  ${props =>  props.$thisStyles}

  ${props =>  props.$isDisabled ? `
    background: #d1d9df;
    color: #95a6af;
    cursor: not-allowed;
  ` : ''}
  &:hover {
    ${props => props.$isDisabled ? `
      background: #d1d9df;
      color: #95a6af;      
  ` : ''}
  }
`;